import type { PropsWithChildren } from "react";

import { styled } from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { BaseCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { ItemIcon, Type } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

const StyledItemIcon = styled(ItemIcon)<{ isPrimary: boolean }>`
    width: 24px;
    height: 24px;

    ${({ isPrimary }) => (isPrimary ? `border: 2px solid ${colorsPalettes.blue[400]};` : "")}
`;

export type DomainCellProps = {
    dataAutomation?: string;
    domain: string;
    icon?: string;
    isPrimary: boolean;
};

export const DomainCell = ({
    children,
    dataAutomation,
    domain,
    icon,
    isPrimary,
}: PropsWithChildren<DomainCellProps>) => {
    const { translate } = useTranslate();

    return (
        <BaseCell dataAutomation={dataAutomation}>
            <Flex
                alignItems="center"
                gap="8px"
            >
                <StyledItemIcon
                    isPrimary={isPrimary}
                    iconType={Type.Website}
                    iconSrc={icon ?? ""}
                />
                <Flex
                    alignItems="center"
                    gap="4px"
                >
                    <Text
                        as="a"
                        href={`https://${domain}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        fontVariant={isPrimary ? "subtitle2" : "body2"}
                    >
                        {isPrimary ? translate("activation.common.your-domain", { domain }) : domain}
                    </Text>
                    {children}
                </Flex>
            </Flex>
        </BaseCell>
    );
};
